import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import log from '@/configured/logger';

const isIe =
  navigator.userAgent.indexOf('MSIE') >= 0 ||
  navigator.appVersion.indexOf('Trident/') > 0;
const isEdge = navigator.appVersion.indexOf('Edge/') > 0;

let exports = {
  supportedFeatures: createSupportedFeaturesMixin(),
};

exports.all = new Vue({
  mixins: [exports.supportedFeatures],
});

export default exports;

/////////

function createSupportedFeaturesMixin() {
  return {
    data() {
      return {
        // 2018-05 IE <= 11 js performance cannot handle persisting the store on save, would require further optimization.
        // 2018-05 Edge currently uses AppCache, implemented differently than iOS <= 11.2 and no debugging tools. It will be implementing service workers and we may support it at that time.
        // jkca: 2023-04-10: disabling for the short term
        supportedFeaturesOfflineMode: false, // !isIe && !isEdge,
        supportedFeaturesWarning: isIe,
      };
    },
    computed: {
      supportedFeaturesTraining() {
        if (this.region === undefined) {
          log.error('You must map the user.region getter to use this mixin');
          return false;
        }
        if (this.isOnline === undefined) {
          log.error(
            'You must map the offline.isOnline state to use this mixin'
          );
          return false;
        }
        return (
          !isIe && !!this.isOnline && this.region && this.region.trainingEnabled
        );
      },
      supportedFeaturesOutbox() {
        if (this.region === undefined) {
          log.error('You must map the user.region getter to use this mixin');
          return false;
        }
        return !isIe && this.region && this.region.outboxEnabled;
      },
      supportedFeaturesSearch() {
        return !isIe;
      },
    },
    ...mapState('offline', ['isOnline']),
  };
}
